import request from "@/util/axios";

// 共享变量
var _shoutu_show_h5_order_tmp_ = {};

const shoutu_show_h5_get_order = function (shoutu_orderNo) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append("shoutu_orderNo", shoutu_orderNo);

    // 查询待支付订单信息 主要是金额
    request.post("/v5/shoutu-order-fee", formData).then((res) => {
      budo_log.info("#14 shoutu-order-fee, res=", res);

      if (res && res.data) {
        res.data.orderFee = Number(res.data.payAmt) * 100;

        _shoutu_show_h5_order_tmp_ = res.data;

        resolve(res.data);
        return;
      }

      reject("shoutu-order-fee err");
    });
  });
};

const shoutu_show_h5_order_info_for_pay = function (cards) {
  budo_log.info("#30 _shoutu_show_h5_order_tmp_=", _shoutu_show_h5_order_tmp_, "cards=", cards);

  _shoutu_show_h5_order_tmp_.cardList = JSON.parse(JSON.stringify(cards));
  _shoutu_show_h5_order_tmp_.cardList.forEach((e) => {
    e.cardUseType = e.useType;
    e.quantity = e.useQuantity; // 这张卡使用了多少
  });

  _shoutu_show_h5_order_tmp_.goodsList = [];

  _shoutu_show_h5_order_tmp_.orderType = "shoutu_h5";
  _shoutu_show_h5_order_tmp_.goodsType = "shoutu_h5";
  _shoutu_show_h5_order_tmp_.tradeno = _shoutu_show_h5_order_tmp_.orderNo;
  _shoutu_show_h5_order_tmp_.expressFee = 0;

  _shoutu_show_h5_order_tmp_.cardMoney = _shoutu_show_h5_order_tmp_.cardList
    .map((e) => e.quantity)
    .reduce((sum, quantity) => sum + quantity, 0);

  _shoutu_show_h5_order_tmp_.wxPayFee = _shoutu_show_h5_order_tmp_.orderFee - _shoutu_show_h5_order_tmp_.cardMoney;

  return _shoutu_show_h5_order_tmp_;
};

export { shoutu_show_h5_get_order, shoutu_show_h5_order_info_for_pay }